import React from 'react';

const STATUS_STYLES = {
  'New': { background: '#e8f3fb', color: '#0a5d94' },
  'In Progress': { background: '#fff3cd', color: '#856404' },
  'P of R': { background: '#faeae4', color: '#8c2d0f' },
  'Revision': { background: '#fde8e8', color: '#7b1f1f' },
  'Client Review': { background: '#d1ecf1', color: '#0c5460' },
  'Completed': { background: '#e6f4ec', color: '#025c2e' },
};
const MODE_STYLES = {
  'Internal': { background: '#f1f3f5', color: '#495057' },
  'Retainer': { background: '#e6f4ec', color: '#037b3e' },
  'Billable': { background: '#fef6e4', color: '#856404' },
  'Non - Billable': { background: '#f1f3f5', color: '#495057' },
};
const ROLE_STYLES = {
  'super_admin': { background: '#e8f3fb', color: '#0a5d94' },
  'manager': { background: '#d1ecf1', color: '#0c5460' },
  'designer': { background: '#faeae4', color: '#8c2d0f' },
};

export default function Badge({ type = 'status', value, customColor }) {
  const styles = type === 'status' ? STATUS_STYLES[value] :
    type === 'mode' ? MODE_STYLES[value] :
      type === 'role' ? ROLE_STYLES[value] :
        customColor ? { background: customColor + '22', color: customColor } :
          { background: '#f1f3f5', color: '#495057' };

  return (
    <span style={{
      display: 'inline-flex', padding: '2px 8px', borderRadius: 12,
      fontSize: 10, fontWeight: 600, whiteSpace: 'nowrap',
      ...styles
    }}>
      {value}
    </span>
  );
}
